import Button from "@/components/Button";
import { Switch } from "@/design-system/Switch/Switch";
import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { pc, playstation, xbox } from "../../../../designSystemIcons";
import { showModal } from "../../../../redux/message/messageSlice";
import { AppDispatch } from "../../../../redux/store";
import {
  getUserSelector,
  updateUser,
  usedFeature,
} from "../../../../redux/user/userSlice";

export const WelcomeModal = ({ welcomeBack }) => {
  const { t } = useTranslation(["auth", "common"]);
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector(getUserSelector);

  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setFadeIn(true);
    }, 50);
  }, []);

  return (
    <div
      className={cn(
        "backdrop-blur-xs backdrop-brightness-50 fixed inset-0 flex z-100 px-4 transition ease-in-out",
        fadeIn ? "opacity-100" : "opacity-0",
      )}
    >
      <div
        className={cn(
          "text-white m-auto top-1/2 -translate-y-1/2 flex flex-col rounded-lg transition ease-in-out gap-y-2 pb-12  p-8 w-[360px] md-lg:w-[539px]",
          fadeIn ? "translate-y-4" : "translate-y-0",
        )}
        style={{
          filter: "drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.5))",
          border:
            "2px solid var(--opacity-10-white, rgba(255, 255, 255, 0.10))",
          background:
            "linear-gradient(113deg, #1C2A37 9.96%, #0F1821 86.37%), #222",
        }}
      >
        <div className="relative">
          <div className="text-lg font-bold text-center text-white md-lg:text-2xl">
            {welcomeBack ? t("welcome.backTitle") : t("welcome.title")}
          </div>
        </div>
        <p className="mx-auto text-sm">{t("welcome.description")}</p>

        <div className="flex mx-auto mt-6 mb-6 gap-x-6">
          <button
            className={cn(
              "flex flex-col rounded-lg p-2 w-[100px] bg-[#1A242D] gap-y-1 items-center outline  shadow-default-drop",
              user?.platform !== "Playstation" && "hover:bg-white/10",
              user?.platform === "Playstation"
                ? "outline-2 outline-primary-blue"
                : "outline-1 outline-white/10",
            )}
            onClick={() => dispatch(updateUser({ platform: "Playstation" }))}
          >
            <p className="text-gray-300">{t("welcome.console")}</p>
            <div className="flex">
              <div className="w-10 h-10 opacity-75">{playstation}</div>
              <div className="w-10 h-10 opacity-75">{xbox}</div>
            </div>
          </button>
          <button
            className={cn(
              "flex flex-col rounded-lg bg-[#1A242D] p-2 w-[100px] gap-y-1 items-center shadow-default-drop outline",
              user?.platform !== "PC" && "hover:bg-white/10",
              user?.platform === "PC"
                ? "outline-2 outline-primary-blue"
                : "outline-1 outline-white/10",
            )}
            onClick={() => dispatch(updateUser({ platform: "PC" }))}
          >
            <p className="text-gray-300">{t("welcome.pc")}</p>
            <div className="w-10 h-10 opacity-75">{pc}</div>
          </button>
        </div>

        <button className="mx-auto text-sm flex justify-between bg-white/10 p-3 rounded-lg backdrop-blur-sm mb-4 text-left">
          <p className="pl-1">{t("common:emailNewsOptIn")}</p>
          <div className="my-auto px-[19px]">
            <Switch
              onChange={() =>
                dispatch(
                  updateUser({ emailNotification: !user?.emailNotification }),
                )
              }
              isActive={user?.emailNotification}
            />
          </div>
        </button>
        <div className="mx-auto">
          <Button
            variant="primary"
            large
            onClick={() => {
              dispatch(usedFeature({ feature: "WELCOME_POPUP" }));
              dispatch(showModal(null));
            }}
            label={welcomeBack ? t("welcome.letsGo") : t("common:getStarted")}
          />
        </div>
      </div>
    </div>
  );
};
